import React from 'react'
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch'
import './zoomableImage.css'

const index = ({ image }) => (
    <TransformWrapper doubleClick={{ disabled: true }}>
        <TransformComponent>
            <img src={image} alt="test" style={{ height: '100%' }} />
        </TransformComponent>
    </TransformWrapper>
)

export default index
